import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthResponseUser } from '../services/authApi';

export interface User {
  jwt: string;
  user: AuthResponseUser;
  allowedRoutes: string[];
}

interface AuthState {
  user: User | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  status: 'idle',
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.status = 'idle';
      state.error = null;
    },
    setCredentials(state, action: PayloadAction<{ user: AuthResponseUser; jwt: string }>) {
      state.user = {
        jwt: action.payload.jwt,
        user: action.payload.user,
        allowedRoutes: [],
      };
    },
  },
  extraReducers: (builder) => {
    // ...
  },
});

export const { logout, setCredentials } = authSlice.actions;
export default authSlice.reducer;
